import { SimpleLayout } from '@/components/Layout';
import LogoImage from '@/assets/logo.png';
import React from 'react';
import { useTranslation } from 'react-i18next';

type LayoutProps = {
  children: React.ReactNode;
};

export const Layout = ({ children }: LayoutProps) => {
  const { t } = useTranslation();

  const policyLinks = [
    { label: t('利用規約'), href: t('terms-and-conditions-url') },
    { label: t('プライバシーポリシー'), href: t('privacy-policy-url') },
    { label: t('データポリシー'), href: t('data-policy-url') },
  ];

  return (
    <SimpleLayout>
      <div className="flex h-full items-center justify-center p-3 pt-10">
        <div className="flex w-full max-w-xl flex-col gap-5 rounded-3xl bg-white p-6 drop-shadow lg:w-3/4 lg:max-w-4xl lg:flex-row lg:items-center lg:p-12">
          <div className="lg:w-1/2">
            <img src={LogoImage} alt="logo image" className="max-h-14" />
            <p className="mt-3 text-gray-500">
              {t(
                '政府やNGO/シンクタンク/国際機関の発信情報を一元化 - 様々な分析画面で新たな発見を'
              )}
            </p>
          </div>
          {/* Content */}
          <div className="w-full lg:w-1/2">
            {children}
            <div className="mt-6 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs text-gray-400">
              {policyLinks.map(({ href, label }) => (
                <a
                  key={label}
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-gray-600"
                >
                  {label}
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </SimpleLayout>
  );
};
